/* eslint-disable no-unused-vars */
import { RSAA } from 'redux-api-middleware';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { REQUEST, SUCCESS, FAILURE } from '@/modules/Requests';
import { formulas } from '@/styledComponents/render/simulators/helpers';
import { options as section } from '@/components/SettingsTeach/fields/SectionField';
import { options as bound } from '@/components/SettingsTeach/fields/BoundField';
import { options as mode } from '@/components/SettingsTeach/fields/ModeField';
import { options as digitsMode } from '@/components/SettingsTeach/fields/DigitsModeField';

import { sortContent } from '@/utils/Helpers';

import { Flex } from 'UIKit/Grid';
import { StyledButtonIcon } from 'UIKit/Form';
import DeleteIcon from '@/assets/img/DeleteIcon.png';
import EditIcon from '@/assets/img/SettingsIcon.png';
import Star from '@/assets/img/Star.png';
import Rate from '@/components/Rate';
import DateCell from '@/components/DataTable/DateCell';
import HomeworkSimulators from '@/components/MainHomeWork/HomeworkSimulators';
import { filterSign } from '@/components/HomeTasks/helpers';
import {
  NO_MODE,
  MULTIPLICATION,
  DIVISION,
  DECIMAL_MODE,
  labels,
  SIGN_ADD,
  SIGN_SUB,
  SIGN_MIX,
  SECTION_MULTIPLICATION_SIMPLE,
  SECTION_MULTIPLICATION_RANDOM,
  SECTION_MULTIPLICATION_ONE_ITERATE,
  SECTION_MULTIPLICATION_MORE_ITERATE,
  SECTION_DIVISION_TABLE,
  SECTION_DIVISION_REMAINDER,
  SECTION_DIVISION_SIMPLE,
  SECTION_DIVISION_RANDOM,
  RULE_SIMPLE_SUM,
} from '@/modules/Simulators';

export const ADD_MAINHOMEWORKS = 'ADD_MAINHOMEWORKS';
export const HOMEWORK_FORM = 'HOMEWORK_FORM';

const host = process.env.BACKEND_URL;
// Init state

/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */

export const types = {
  SET_MAINHOMEWORKS: 'SET_MAINHOMEWORK',
  REQUEST_MAINHOMEWORKS: 'REQUEST_MAINHOMEWORKS',
  REQUEST_TEACHER_MAINHOMEWORKS: 'REQUEST_TEACHER_MAINHOMEWORKS',
  REQUEST_STATUSMAINHOMEWORKS_CHANGE: 'REQUEST_STATUSMAINHOMEWORKS_CHANGE',
  REQUEST_MAINHOMEWORKS_CREATE: 'REQUEST_MAINHOMEWORKS_CREATE',
  REQUEST_MAINHOMEWORKS_RATE: 'REQUEST_MAINHOMEWORKS_RATE',
  REQUEST_MAINHOMEWORKS_DELETE: 'REQUEST_MAINHOMEWORKS_DELETE',
  REQUEST_MAINHOMEWORKS_DELETE_MANY: 'REQUEST_MAINHOMEWORKS_DELETE_MANY',
  REQUEST_MAINHOMEWORKS_EDIT: 'REQUEST_MAINHOMEWORKS_EDIT',
  REQUEST_MAINHOMEWORKS_ID: 'REQUEST_MAINHOMEWORKS_ID',
  RESET_MAINHOMEWORKS: 'RESET_MAINHOMEWORKS',
  REQUEST_MAINHOMEWORKS_COMPLETED: 'REQUEST_MAINHOMEWORKS_COMPLETED',
  REQUEST_MAINHOMEWORKS_DAILY_ACCESS: 'REQUEST_MAINHOMEWORKS_DAILY_ACCESS',
  SET_FILTER: 'SET_FILTER',
};

const initialState = {
  studentswork: [],
  works: [],
  filter: {},
  countCompleted: 0,
};

// Reducer
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_MAINHOMEWORKS:
      return {
        ...state,
        [action.meta]: action.payload,
      };
    case types.RESET_MAINHOMEWORKS:
      return {
        ...state,
        studentswork: [],
        works: [],
      };
    case types.SET_FILTER:
      return {
        ...state,
        filter: action.payload,
      };
    default:
      return state;
  }
};

// Actions
const fetchMainhomework = () => ({
  [RSAA]: {
    endpoint: `${host}/main-homeworks`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_MAINHOMEWORKS,
      },
    })),
  },
});

const fetchTeacherMainhomework = (page, date) => ({
  [RSAA]: {
    endpoint: `${host}/main-homeworks/format/`,
    method: 'POST',
    body: JSON.stringify({ page, date }),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_TEACHER_MAINHOMEWORKS,
      },
    })),
  },
});

const fetchMainhomeworkById = id => ({
  [RSAA]: {
    endpoint: `${host}/main-homeworks/${id}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_MAINHOMEWORKS_ID,
      },
    })),
  },
});

const fetchMainhomeworkCreate = formData => ({
  [RSAA]: {
    endpoint: `${host}/main-homeworks/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_MAINHOMEWORKS_CREATE,
      },
    })),
  },
});

const fetchMainhomeworkRate = (id, rate) => ({
  [RSAA]: {
    endpoint: `${host}/main-homeworks/rate/${id}`,
    method: 'POST',
    body: JSON.stringify(rate),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_MAINHOMEWORKS_RATE,
      },
    })),
  },
});
const fetchMainhomeworkDelete = id => ({
  [RSAA]: {
    endpoint: `${host}/main-homeworks/delete/${id}`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_MAINHOMEWORKS_DELETE,
      },
    })),
  },
});

const fetchMainhomeworkDeleteMany = ids => ({
  [RSAA]: {
    endpoint: `${host}/main-homeworks/delete`,
    method: 'POST',
    body: JSON.stringify(ids),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_MAINHOMEWORKS_DELETE_MANY,
      },
    })),
  },
});

const fetchMainhomeworkEdit = (id, data) => ({
  [RSAA]: {
    endpoint: `${host}/main-homeworks/${id}`,
    method: 'PUT',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_MAINHOMEWORKS_EDIT,
      },
    })),
  },
});

const fetchMainCompleted = () => ({
  [RSAA]: {
    endpoint: `${host}/main-homeworks/completed`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_MAINHOMEWORKS_COMPLETED,
      },
    })),
  },
});

const fetchDailyAccess = () => ({
  [RSAA]: {
    endpoint: `${host}/main-homeworks/daily-access`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_MAINHOMEWORKS_DAILY_ACCESS,
      },
    })),
  },
});

const setMainhomeworkFilter = filter => ({
  type: types.SET_FILTER,
  payload: filter,
});

export const actions = {
  fetchMainhomeworkById,
  fetchMainhomeworkCreate,
  fetchMainhomeworkDelete,
  fetchMainhomeworkDeleteMany,
  fetchMainhomeworkEdit,
  fetchMainhomework,
  fetchTeacherMainhomework,
  resetMainhomeworks: () => ({ type: types.RESET_MAINHOMEWORKS }),
  fetchMainhomeworkRate,
  setMainhomeworkFilter,
  fetchMainCompleted,
  fetchDailyAccess,
};

export const simulators = [
  {
    value: 'roomA',
    label: labels.roomA,
  },
  {
    value: 'roomB',
    label: labels.roomB,
  },
  {
    value: 'roomC',
    label: labels.roomC,
  },
];

export const trainerOptions = {
  simulator: (rooms, intl) =>
    rooms.map(item => ({
      value: item._id,
      label: intl.formatMessage({ id: item.name }),
    })),
  mode,
  bound,
  numbers: (rule, sign) =>
    rule === 0 || (rule >= 2 && rule <= 4)
      ? Object.entries(formulas[sign][rule]).map(formula => ({
          value: formula[0],
          label: formula[1],
        }))
      : [],
};

export const trainerParams = {
  mode,
  sign: [
    {
      value: SIGN_ADD,
      label: '+',
    },
    {
      value: SIGN_SUB,
      label: '-',
    },
    {
      value: SIGN_MIX,
      label: '-/+',
    },
  ],
  numbers: formulas,
  bound,
  digits_mode: digitsMode,
};

const optionNoMode = [
  { value: 11, label: 'NEGATIVE_NUMBERS' },
  { value: 12, label: 'NEGATIVE_ANSWER' },
];

const optionMulti = [
  { value: 1, label: 'MULTIPLICATION_TABLE' },
  { value: 2, label: 'MULTIPLICATION_SIMPLE' },
  { value: 3, label: 'MULTIPLICATION_RANDOM' },
  { value: 4, label: 'MULTIPLICATION_ONE_ITERATE' },
  { value: 5, label: 'MULTIPLICATION_MORE_ITERATE' },
];

const optionDiv = [
  { value: 1, label: 'DIVISION_TABLE' },
  { value: 2, label: 'DIVISION_REMAINDER' },
  { value: 3, label: 'DIVISION_SIMPLE' },
  { value: 4, label: 'DIVISION_ONE_ITERATE' },
  { value: 5, label: 'DIVISION_MORE_ITERATE' },
  { value: 6, label: 'DIVISION_SAME' },
  { value: 7, label: 'DIVISION_BY_ONE' },
  { value: 8, label: 'DIVISION_RANDOM' },
];

export const optionAnswerDischargeTypes = intl => [
  {
    value: 'random',
    label: intl.formatMessage({ id: 'DIGITS_MODE_RANDOM_RANGE' }),
  },
  { value: 'min', label: intl.formatMessage({ id: 'DIGITS_MODE_MIN_RANGE' }) },
  { value: 'max', label: intl.formatMessage({ id: 'DIGITS_MODE_MAX_RANGE' }) },
];

const optionSimpleFirstInt = [
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  { label: 7, value: 7 },
  { label: 8, value: 8 },
  { label: 9, value: 9 },
];
export const optionMultiFirstInt = [
  { value: 1, label: '2D*1D' },
  { value: 2, label: '3D*1D' },
  { value: 3, label: '3D*2D' },
];

export const stepsOptions = [
  {
    value: 1,
    label: 1,
  },
  {
    value: 2,
    label: 2,
  },
  {
    value: 3,
    label: 3,
  },
  {
    value: 4,
    label: 4,
  },
  {
    value: 5,
    label: 5,
  },
  {
    value: 6,
    label: 6,
  },
  {
    value: 7,
    label: 7,
  },
  {
    value: 8,
    label: 8,
  },
  {
    value: 9,
    label: 9,
  },
  {
    value: 10,
    label: 10,
  },
  {
    value: 12,
    label: 12,
  },
  {
    value: 15,
    label: 15,
  },
  {
    value: 18,
    label: 18,
  },
  {
    value: 20,
    label: 20,
  },
  {
    value: 25,
    label: 25,
  },
  {
    value: 30,
    label: 30,
  },
];

export const stepsAnzanOptions = [
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
  { value: 7, label: 7 },
  { value: 8, label: 8 },
  { value: 9, label: 9 },
  { value: 10, label: 10 },
  { value: 12, label: 12 },
  { value: 15, label: 15 },
  { value: 18, label: 18 },
  { value: 20, label: 20 },
  { value: 25, label: 25 },
  { value: 30, label: 30 },
  { value: 35, label: 35 },
  { value: 40, label: 40 },
  { value: 45, label: 45 },
  { value: 50, label: 50 },
  { value: 55, label: 55 },
  { value: 60, label: 60 },
  { value: 65, label: 65 },
  { value: 70, label: 70 },
  { value: 75, label: 75 },
  { value: 80, label: 80 },
  { value: 85, label: 85 },
  { value: 90, label: 90 },
  { value: 95, label: 95 },
  { value: 100, label: 100 },
];

export const getFirstIntOption = rule => {
  if (rule === 'multi') {
    return optionMultiFirstInt;
  }

  return optionSimpleFirstInt;
};

export const getCommonParams = (intl, selectedMode, getSectionOption) => ({
  steps: { value: 2, label: 2 },
  interval: 1,
  mode: {
    value: RULE_SIMPLE_SUM,
    label: intl.formatMessage({ id: 'RULE_SIMPLE_SUM' }),
  },
  section: getSectionOption(selectedMode, intl)[0],
  sign: { value: 0, label: '+' },
  digit: [1, 2],
  bound: {
    value: 0,
    label: intl.formatMessage({ id: 'NOT_EXCEED_50' }),
  },
  max_discharge: true,
});

export const getSchulteParams = intl => ({
  mode: {
    value: 'SCHULTE',
    label: 'Schulte',
  }, // mode не нужен там, но без него логика ДЗ ломается поэтому как заглушка для шульте

  size: { value: 3, label: '3x3' },

  tableType: {
    value: 'card',
    label: intl.formatMessage({ id: 'NUMBERS' }),
  },

  symbolOrder: {
    value: 'direct',
    label: intl.formatMessage({ id: 'DIRECT_ORDER' }),
  },

  isCenterDot: {
    value: false,
    label: intl.formatMessage({ id: 'NO' }),
  },

  isShuffleOnClick: {
    value: false,
    label: intl.formatMessage({ id: 'NO' }),
  },

  timeLimitMode: {
    value: 'unlimited',
    label: intl.formatMessage({ id: 'UNLIMITED_TIME' }),
  },

  timeLimitSeconds: 60,

  volume: {
    value: 50,
    label: '50%',
  },

  numberDigit: {
    value: 1,
    label: '1',
  },
});

export const optionsTrainer = (homeworks, rooms, intl) => {
  const filtredHomeworks = hworks =>
    hworks.map(homework => ({
      count: homework.count,
      comment: homework.comment,
      sound: homework.sound,
      sample: homework.sample,
      showInRow: homework.showInRow,
      simulator: homework.simulator,
      id: homework.id,
      ...homework.params,
    }));

  return filtredHomeworks(homeworks).map(hw => {
    const modeValue = hw.mode;
    const sectionValue = hw.section;

    return Object.entries(hw).reduce((acc, el, _, arr) => {
      const key = el[0];
      const value = el[1];

      if (key === 'simulator') {
        // стандартно как и было
        let matchedOption = trainerOptions
          .simulator(rooms, intl)
          .find(opt => opt.value === value?.id);

        // дальше обработка ДЗ доставшихся от предыдущего педагога
        // 2. Фолбэк по имени (ПРИ смене учеником педагога и ID не совпадают)
        if (!matchedOption && value?.name) {
          const newRoom = rooms.find(r => r.name === value.name);
          if (newRoom) {
            matchedOption = {
              value: newRoom._id,
              label: intl.formatMessage({ id: newRoom.name }),
            };
          }
        }
        // 3. Крайний фолбэк (если тренажер вообще не найден в системе, чтобы форма не отправила undefined)
        if (!matchedOption && value?.id) {
          matchedOption = {
            value: value.id,
            label: value?.name || 'Неизвестный тренажер',
          };
        }

        acc[key] = matchedOption;
        return acc;
      }

      // боже это такой кринж, можно я не буду это переписывать на понятный язык
      if (key === 'section') {
        const currentMode = arr.find(els => els[0] === 'mode')[1];
        acc[key] = getSectionOption(currentMode, intl).find(
          opt => opt.value === value
        );
        return acc;
      }

      if (key === 'numbers') {
        const currentMode = arr.find(els => els[0] === 'mode')[1];
        const sign = arr.find(els => els[0] === 'sign')[1];
        acc[key] = trainerOptions
          .numbers(currentMode, sign)
          .filter(opt => value.includes(opt.value));
        return acc;
      }

      if (key === 'sign') {
        acc[key] = trainerParams.sign.find(opt => opt.value === value);
        return acc;
      }

      if (trainerOptions[key]) {
        const currentOpt = trainerOptions[key].find(opt => opt.value === value);

        if (!currentOpt) {
          acc[key] = {
            value,
            label: typeof value === 'string' ? value : String(value),
          };
          return acc;
        }
        acc[key] = {
          value: currentOpt.value,
          label: intl.formatMessage({ id: currentOpt.label }),
        };
        return acc;
      }

      if (key === 'max_discharge' || key === 'min_discharge') {
        acc[key] = true;
        return acc;
      }

      if (Array.isArray(value)) {
        acc[key] = value.map(v => ({ value: v, label: v }));
        return acc;
      }

      if (key === 'first_int') {
        const rule = simpleInt(modeValue, sectionValue);
        const options =
          rule === 'multi' ? optionMultiFirstInt : optionSimpleFirstInt;
        const matchedOption = options.find(opt => opt.value === value);
        acc[key] = matchedOption || { value, label: value };
        return acc;
      }

      if (key === 'under') {
        const over = arr.find(els => els[0] === 'over')[1];
        acc.digit = [value, over];
        return acc;
      }

      if (key === 'over') {
        return acc;
      }

      if (
        [
          'count',
          'interval',
          'sound',
          'showInRow',
          'sample',
          'comment',
        ].includes(key)
      ) {
        acc[key] = value;
        return acc;
      }

      acc[key] = {
        value,
        label: value,
      };

      return acc;
    }, {});
  });
};

export const getSectionOption = (rule, intl) => {
  const formatted = opts =>
    opts.map(option => ({
      value: option.value,
      label: intl.formatMessage({ id: option.label }),
    }));

  if (rule === NO_MODE || rule === DECIMAL_MODE) {
    return formatted(optionNoMode);
  }

  if (rule === MULTIPLICATION) {
    return formatted(optionMulti);
  }

  if (rule === DIVISION) {
    return formatted(optionDiv);
  }

  return formatted(section);
};

const priorityParms = intl => [
  `${intl.formatMessage({ id: 'rule' })}`,
  `${intl.formatMessage({ id: 'section' })}`,
  `${intl.formatMessage({ id: 'digit' })}`,
  `${intl.formatMessage({ id: 'max_discharge' })}`,
  `${intl.formatMessage({ id: 'min_discharge' })}`,
  `${intl.formatMessage({
    id: 'formulas',
  })}`,
  `${intl.formatMessage({
    id: 'dividend',
  })}`,
  `${intl.formatMessage({
    id: 'divider',
  })}`,
  `${intl.formatMessage({
    id: 'MULTIPLIER',
  })}`,
  `${intl.formatMessage({
    id: 'first_int_available_numbers',
  })}`,
  `${intl.formatMessage({
    id: 'second_int_available_numbers',
  })}`,
  `${intl.formatMessage({ id: 'numbers_of_terms' })}`,
  `${intl.formatMessage({ id: 'steps' })}`,
  `${intl.formatMessage({ id: 'sign' })}`,
  `${intl.formatMessage({ id: 'bound' })}`,
  `${intl.formatMessage({ id: 'interval' })}`,
  `${intl.formatMessage({ id: 'NUMBER_OF_EXAMPLES' })}`,
];
// getParamsText участвует в переводе парамсов в панели ученика на главной странице Профиля
export const getParamsText = (content, rooms, intl) =>
  content.flat().map(c => {
    // console.group('🔍 DEBUG: Поиск тренажера');
    // console.log('Ищем ID:', c?.simulator?.id, 'Тип:', typeof c.simulator?.id);
    // console.log(
    //   'Список доступных IDs:',
    //   rooms?.map(r => r.id)
    // );
    // console.log(
    //   'Результат поиска (.id):',
    //   rooms?.find(room => room.id === c.simulator.id)
    // );
    // console.log(
    //   'Результат поиска (._id):',
    //   rooms?.find(room => room._id === c.simulator.id)
    // );
    // console.groupEnd();
    const simulator = c.simulator
      ? {
          name: c.simulator.name,
          label:
            rooms?.find(room => room.id === c.simulator.id)?.desc ||
            'Не найден',
          id: c.simulator.id,
        }
      : '';

    return {
      simulator,
      settings: [
        ...sortContent(
          Object.entries(c).reduce((acc, sett, _, arr) => {
            const key = sett[0];
            const value = sett[1];
            const currentMode = arr.find(el => el[0] === 'mode')?.[1];
            const modeName = trainerParams.mode.find(
              m => m.value === currentMode
            )?.label;

            if (key !== 'simulator' && key !== 'status' && key !== 'id') {
              // ========== БЛОК НАСТРОЕК ТАБЛИЦЫ ШУЛЬТЕ ==========
              if (key === 'size') {
                acc.push(
                  `${intl.formatMessage({
                    id: 'TABLE_SIZE',
                  })}: ${value}x${value}`
                );
                return acc;
              }
              if (key === 'timeLimitMode') {
                const labelId =
                  value === 'limited' ? 'LIMITED_TIME' : 'UNLIMITED_TIME';
                acc.push(
                  `${intl.formatMessage({
                    id: 'TIME_LIMIT_MODE',
                  })}: ${intl.formatMessage({ id: labelId })}`
                );
                return acc;
              }
              if (key === 'timeLimitSeconds') {
                // Показываем только если режим limited
                const timeMode = arr.find(el => el[0] === 'timeLimitMode')?.[1];
                if (timeMode === 'limited') {
                  const minutes = Math.floor(value / 60);
                  const seconds = value % 60;
                  const timeString = `${minutes
                    .toString()
                    .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                  acc.push(
                    `${intl.formatMessage({
                      id: 'TIME_LIMIT_VALUE',
                    })}: ${timeString}`
                  );
                }
                return acc;
              }
              if (key === 'volume') {
                if (value !== undefined) {
                  acc.push(
                    `${intl.formatMessage({ id: 'SOUND_VOLUME' })}: ${value}%`
                  );
                }
                return acc;
              }
              if (key === 'numberDigit') {
                acc.push(
                  `${intl.formatMessage({ id: 'NUMBER_DIGITS' })}: ${value}`
                );
                return acc;
              }
              if (key === 'isShuffleOnClick') {
                const label = value
                  ? intl.formatMessage({ id: 'YES' })
                  : intl.formatMessage({ id: 'NO' });
                acc.push(
                  `${intl.formatMessage({ id: 'SHUFFLE_ON_CLICK' })}: ${label}`
                );
                return acc;
              }
              if (key === 'isCenterDot') {
                const label = value
                  ? intl.formatMessage({ id: 'YES' })
                  : intl.formatMessage({ id: 'NO' });
                acc.push(
                  `${intl.formatMessage({ id: 'CENTER_DOT' })}: ${label}`
                );
                return acc;
              }
              if (key === 'symbolOrder') {
                const labelId =
                  value === 'direct'
                    ? 'DIRECT_ORDER'
                    : value === 'reverse'
                    ? 'REVERSE_ORDER'
                    : 'RANDOM_ORDER';
                acc.push(
                  `${intl.formatMessage({
                    id: 'SYMBOL_ORDER',
                  })}: ${intl.formatMessage({ id: labelId })}`
                );
                return acc;
              }
              if (key === 'tableType') {
                const labelId = value === 'abacus' ? 'ABACUS' : 'NUMBERS';
                acc.push(
                  `${intl.formatMessage({
                    id: 'TABLE_TYPE',
                  })}: ${intl.formatMessage({ id: labelId })}`
                );
                return acc;
              }
              // ====== ==========
              if (trainerParams[key]) {
                if (key === 'numbers') {
                  const sign = arr.find(el => el[0] === 'sign')[1];
                  const currentFormulas = trainerParams[key][sign][currentMode]
                    ? Object.entries(trainerParams[key][sign][currentMode])
                    : [];
                  const formulaValues = currentFormulas.reduce(
                    (formuls, formula) => {
                      if (value.includes(formula[0])) {
                        formuls.push(formula[1]);
                        return formuls;
                      }
                      return formuls;
                    },
                    []
                  );
                  acc.push(
                    `${intl.formatMessage({
                      id: 'formulas',
                    })} ${formulaValues.join(', ')}`
                  );
                  return acc;
                }

                if (key === 'mode') {
                  if (value === 'Schulte') {
                    return acc;
                  }

                  const currentParam = trainerParams[key]?.find(
                    param => param.value === value
                  );

                  if (!currentParam) {
                    return acc;
                  }

                  acc.push(
                    `${intl.formatMessage({
                      id: 'rule',
                    })}: ${intl.formatMessage({
                      id: currentParam.label,
                    })}`
                  );

                  return acc;
                }

                if (key === 'sign') {
                  if (modeName && !filterSign(modeName)) return acc;

                  const currentSign = trainerParams[key]?.find(
                    sign => sign.value === value
                  );

                  if (!currentSign) {
                    return acc;
                  }

                  acc.push(
                    `${intl.formatMessage({ id: 'sign' })}: ${
                      currentSign.label
                    }`
                  );

                  return acc;
                }

                const currentParam = trainerParams[key]?.find(
                  param => param.value === value
                );

                if (!currentParam) {
                  return acc;
                }

                acc.push(
                  `${intl.formatMessage({ id: key })}: ${intl.formatMessage({
                    id: currentParam.label,
                  })}`
                );

                return acc;
              }

              if (key === 'min_discharge' || key === 'max_discharge') {
                acc.push(`${intl.formatMessage({ id: key })}`);
                return acc;
              }

              if (key === 'section') {
                const { label } = getSectionOption(currentMode, intl).find(
                  el => el.value === value
                );
                acc.push(
                  `${intl.formatMessage({
                    id: 'section',
                  })}: ${label}`
                );
                return acc;
              }

              if (key === 'answer_discharge_type') {
                const label = intl.formatMessage({
                  id: 'ANSWER_DISCHARGE_TYPE',
                });
                let translatedValue;

                switch (value) {
                  case 'random':
                    translatedValue = intl.formatMessage({
                      id: 'DIGITS_MODE_RANDOM_RANGE',
                    });
                    break;
                  case 'min':
                    translatedValue = intl.formatMessage({
                      id: 'DIGITS_MODE_MIN_RANGE',
                    });
                    break;
                  case 'max':
                    translatedValue = intl.formatMessage({
                      id: 'DIGITS_MODE_MAX_RANGE',
                    });
                    break;
                  default:
                    translatedValue = value;
                }

                acc.push(`${label}: ${translatedValue}`);
                return acc;
              }

              if (key === 'rotation_type') {
                const label = intl.formatMessage({
                  id: 'ROTATION_TYPE',
                });
                let translatedValue;

                switch (value) {
                  case 0:
                    translatedValue = intl.formatMessage({
                      id: 'RANDOM_ROTATION',
                    });
                    break;
                  case 1:
                    translatedValue = intl.formatMessage({
                      id: 'SINGLE_ROTATION',
                    });
                    break;
                  case 2:
                    translatedValue = intl.formatMessage({
                      id: 'DOUBLE_ROTATION',
                    });
                    break;
                  default:
                    translatedValue = value;
                }

                acc.push(`${label}: ${translatedValue}`);
                return acc;
              }

              if (key === 'first_int') {
                if ([9, 10].includes(currentMode)) {
                  acc.push(
                    `${intl.formatMessage({
                      id: 'digit',
                    })}: ${value}`
                  );
                  return acc;
                }

                if ([7, 8].includes(currentMode)) {
                  acc.push(
                    `${intl.formatMessage({
                      id: 'ANSWER_DISCHARGE',
                    })}: ${value}`
                  );
                  return acc;
                }
              }

              if (key === 'first_int' || key === 'table') {
                const multiplication =
                  currentMode === MULTIPLICATION
                    ? 'first_int_available_numbers'
                    : 'dividend';
                const currentValue = Array.isArray(value)
                  ? value.join(', ')
                  : value;

                acc.push(
                  `${intl.formatMessage({
                    id: currentMode >= 7 ? 'digit' : multiplication,
                  })}: ${currentValue}`
                );
                return acc;
              }

              if (key === 'second_int') {
                const multiplication =
                  currentMode === MULTIPLICATION
                    ? 'second_int_available_numbers'
                    : 'divider';

                acc.push(
                  `${intl.formatMessage({
                    id: multiplication,
                  })}: ${value}`
                );
                return acc;
              }

              if (key === 'under') {
                if (currentMode >= 7 && currentMode !== 11) return acc;

                const over = arr.find(el => el[0] === 'over')[1];
                acc.push(
                  `${intl.formatMessage({ id: 'digit' })}: ${intl.formatMessage(
                    {
                      id: key,
                    }
                  )}: ${value} ${intl.formatMessage({ id: 'over' })}: ${over}`
                );
                return acc;
              }

              if (key === 'sound') {
                if (value) acc.push(intl.formatMessage({ id: 'SOUND' }));
                return acc;
              }

              if (key === 'showInRow') {
                if (value) acc.push(intl.formatMessage({ id: 'SHOW_IN_ROW' }));
                return acc;
              }

              if (key === 'sample') {
                if (value)
                  acc.push(intl.formatMessage({ id: 'SHOW_EXAMPLES' }));
                return acc;
              }

              if (key === 'comment') {
                if (value)
                  acc.push(
                    `${intl.formatMessage({ id: 'comment' })}: ${value}`
                  );
                return acc;
              }
              if (key === 'steps') {
                if (currentMode >= 7) return acc;
                if (value)
                  acc.push(`${intl.formatMessage({ id: 'steps' })}: ${value}`);
                return acc;
              }
              if (key === 'interval') {
                if (currentMode >= 7) return acc;
                if (value)
                  acc.push(
                    `${intl.formatMessage({ id: 'interval' })}: ${value}`
                  );
                return acc;
              }

              if (key === 'over') {
                return acc;
              }

              acc.push(`${intl.formatMessage({ id: key })}: ${value}`);

              return acc;
            }
            return acc;
          }, []),
          priorityParms(intl)
        ),
      ],
    };
  });

export const formatHomeworks = (data, component) => {
  const {
    intl,
    page,
    user: { rooms },
  } = component.props;

  const { dateSort } = component.state;

  const result = [];

  let lastStudent;

  /* т.к. на вход идут документы, здесь преобразовываем их в табличный вид
       с учетом rowSpan'ов для каждой новой строки. если не изменились данные ячейки,
       ищем сколько строк займет эта ячейка. если повторяются - пропускаем (span 0)

    */

  data.forEach(stud => {
    let lastHomework;

    stud.studHomeworks

      .sort((a, b) => {
        if (a.completionDay > b.completionDay || !b.completionDay)
          return dateSort ? 1 : -1;
        if (a.completionDay === b.completionDay) return 0;
        return dateSort ? -1 : 1;
      })
      .sort((a, b) => {
        if (a.groups?.name > b.groups?.name || !a.groups) return 1;
        if (a.groups?.name === b.groups?.name) return 0;
        return -1;
      })
      .forEach(studHw => {
        const { dates, completionDay, progress, created_at, groups } = studHw;

        const width = page === PAGES.AWAIT ? 4 : page === PAGES.NEW ? 2 : 3;

        result.push({
          name: {
            value: (
              <Flex
                flexDirection="column"
                justifyContent="center"
                style={{ textAlign: 'center' }}
              >
                {stud.name} {stud.surname}
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  pt="2"
                  style={{ gap: 5 }}
                >
                  <img src={Star} alt="" /> {stud.stars}
                </Flex>
              </Flex>
            ),
            span: stud._id !== lastStudent?._id ? stud.studHomeworks.length : 0,
          },
          groups: {
            value: groups?.name || intl.formatMessage({ id: 'individ' }),
            span:
              groups?._id !== lastHomework?.groups?._id ||
              lastHomework === undefined
                ? stud.studHomeworks.reduce(
                    (sum, item) =>
                      sum + Number(item.groups?._id === groups?._id),
                    0
                  )
                : 0,
          },
          dates: {
            value: (
              <DateCell
                dates={{
                  ...dates,
                  createDay: created_at,
                  completionDay,
                }}
              />
            ),
            span: 1,
          },
          tasks: {
            value: studHw.homeworks.length,
            span: 1,
          },
          simulator: {
            value: (
              <HomeworkSimulators
                data={studHw.homeworks}
                colSpan={width}
                page={page}
                intl={intl}
                rooms={rooms}
                component={component}
                getParamsText={getParamsText}
              />
            ),
            span: 1,
            width,
          },
          params: {
            span: 0,
          },
          results: {
            span: 0,
          },
          status: {
            value: intl.formatMessage({ id: INTL[progress] }),
            span: Number(page !== PAGES.AWAIT),
          },
          rate: {
            value: (
              <Flex
                flexDirection="column"
                style={{ gap: 10 }}
                alignItems="center"
              >
                <Flex justifyContent="center" style={{ flexWrap: 'wrap' }}>
                  {Array.from({ length: studHw.stars }).map(() => (
                    <img src={Star} alt="" />
                  ))}
                </Flex>
                <span>{studHw.comment}</span>
              </Flex>
            ),
            span: 1,
          },
          action: {
            value: (
              <>
                {page === PAGES.NEW && (
                  <div
                    style={{
                      display: 'flex',
                      gap: '2px',
                    }}
                  >
                    <Tooltip
                      title={intl.formatMessage({
                        id: 'HOMEWORK_TABLE_SAVE_TITLE',
                      })}
                      placement="right"
                    >
                      <StyledButtonIcon
                        type="button"
                        onClick={
                          progress === INTL.new
                            ? () => component.handleEdit(studHw.id)
                            : () =>
                                component.handleOpenModal({
                                  id: studHw.id,
                                  type:
                                    [INTL.success, INTL.overfill].includes(
                                      progress
                                    ) &&
                                    dates.deadlineDay &&
                                    !dates.daily
                                      ? 'cant_edit'
                                      : 'edit',
                                })
                        }
                        del="true"
                      >
                        <img src={EditIcon} alt="" />
                      </StyledButtonIcon>
                    </Tooltip>
                    <Tooltip
                      title={intl.formatMessage({
                        id: 'DELETE_HOMEWORK',
                      })}
                      placement="right"
                    >
                      <StyledButtonIcon
                        type="button"
                        onClick={() =>
                          component.handleOpenModal({
                            type:
                              [INTL.success, INTL.overfill].includes(
                                progress
                              ) &&
                              dates.deadlineDay &&
                              !dates.daily
                                ? 'cant_delete'
                                : 'delete',
                            id: studHw.id,
                          })
                        }
                        del="true"
                      >
                        <img src={DeleteIcon} alt="" />
                      </StyledButtonIcon>
                    </Tooltip>
                  </div>
                )}
                {page === PAGES.COMPLETED && (
                  <Rate
                    name={studHw._id}
                    onRate={rate => component.handleRate(studHw._id, rate)}
                  />
                )}
              </>
            ),
            span: Number(page !== PAGES.AWAIT),
          },
        });

        lastHomework = studHw;
        lastStudent = stud;
      });
  });
  return result;
};

export const DAYS = [
  { value: '', label: 'FILTER_ALL' },
  { value: 'completionDay', label: 'COMPLETED' },
  { value: 'certainDays', label: 'BY_DAYS' },
  { value: 'deadlineDay', label: 'COMPLETE_OVER' },
  { value: 'daily', label: 'daily' },
];

export const firstInt = [
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
  { value: 7, label: 7 },
  { value: 8, label: 8 },
];

export const secondInt = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
];

export const digitsNumbers = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
  { value: 7, label: 7 },
];

// Отображение делителей / множетелей
export const visilyInts = (modeValue, sectionValue) =>
  (modeValue === MULTIPLICATION &&
    sectionValue === SECTION_MULTIPLICATION_RANDOM) ||
  (modeValue === DIVISION && sectionValue === SECTION_DIVISION_RANDOM);

export const visilyInt = (modeValue, sectionValue) =>
  (modeValue === MULTIPLICATION &&
    sectionValue !== SECTION_MULTIPLICATION_RANDOM) ||
  (modeValue === DIVISION &&
    (sectionValue === SECTION_DIVISION_TABLE ||
      sectionValue === SECTION_DIVISION_REMAINDER));

export const simpleInt = (modeValue, sectionValue) =>
  modeValue === MULTIPLICATION &&
  (sectionValue === SECTION_MULTIPLICATION_ONE_ITERATE ||
    sectionValue === SECTION_MULTIPLICATION_MORE_ITERATE)
    ? 'multi'
    : 'simple';

export const visilyDischarge = (modeValue, sectionValue) =>
  (modeValue === MULTIPLICATION &&
    sectionValue === SECTION_MULTIPLICATION_SIMPLE) ||
  (modeValue === DIVISION &&
    sectionValue >= SECTION_DIVISION_SIMPLE &&
    sectionValue < SECTION_DIVISION_RANDOM);

export const PAGES = {
  NEW: 'new',
  AWAIT: 'await',
  COMPLETED: 'completed',
  HISTORY: 'history',
};

export const INTL = {
  new: 'new',
  process: 'process',
  success: 'success',
  overfill: 'overfill',
};

export default reducer;
